import { render, staticRenderFns } from "./ChargingYourEvTabs.vue?vue&type=template&id=383181fc&scoped=true&"
import script from "./ChargingYourEvTabs.vue?vue&type=script&lang=js&"
export * from "./ChargingYourEvTabs.vue?vue&type=script&lang=js&"
import style0 from "./ChargingYourEvTabs.vue?vue&type=style&index=0&id=383181fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383181fc",
  null
  
)

export default component.exports